<script lang="ts">
import { OpportunityService } from '~/services/opportunity.service'
import { Opportunity } from '~/models/Opportunity'
import { BaseRoutesEnum } from '~/enum/BaseRoutes.enum'
import OrganizationData = App.Data.Organization.OrganizationData
import IntentionData = PildomModules.Voirie.Data.IntentionData

export default {
    name: 'OpportunityIntention',
    components: { },
    props: {
        opportunityData: { type: Object, required: true },
        intentionData: { type: Object, required: true },
        isCurrent: { type: Boolean, required: false, default: false },

    },
    data() {
        return {
            opportunityService: null as OpportunityService,
            intentionsTranslation: 'voirie.intentions',
        }
    },

    computed: {
        organization(): OrganizationData {
            return (this.intentionData as IntentionData).organization
        },
        intentionBaseUrl(): string {
            const route = useRoute()
            return route.path.startsWith(BaseRoutesEnum.myOpportunities)
                ? BaseRoutesEnum.myIntentions
                : BaseRoutesEnum.allIntentions
        },
    },
    beforeMount() {
        this.initService()
    },
    methods: {
        initService(): void {
            this.opportunityService = new OpportunityService(new Opportunity(this.opportunityData))
        },
    },
}
</script>

<!-- eslint-disable vue/no-restricted-v-bind -->
<template>
    <div>
        <FormSection title="Informations générales" with-borders-color="primary">
            <FormSelect
                data-key="status"
                :data="intentionData"
                is-chips
                :translation-name="intentionsTranslation"
            />
            <FormInput
                data-key="name"
                :data="intentionData"
                :translation-name="intentionsTranslation"
            >
                <template #appendContent>
                    <a :href="`${intentionBaseUrl}/${intentionData.k}`" class="text-secondary ml-2" @click.prevent="$router.push(`${intentionBaseUrl}/${intentionData.k}`)">
                        Voir la fiche de l'intention
                    </a>
                </template>
            </FormInput>
            <FormInput
                data-key="organization.t"
                :data="intentionData"
                :translation-name="intentionsTranslation"
            />
            <FormInput
                data-key="commune.t"
                :data="intentionData"
                :translation-name="intentionsTranslation"
            />
            <FormInput
                data-key="ban_street"
                :data="intentionData"
                :translation-name="intentionsTranslation"
            />
            <FormSelect
                data-key="due_status"
                :data="intentionData"
                is-chips
                :translation-name="intentionsTranslation"
            />
            <FormInput
                data-key="year"
                :data="intentionData"
                :translation-name="intentionsTranslation"
            />
        </FormSection>

        <FormSection title="Contact" with-borders-color="primary">
            <FormInput
                data-key="contact_name"
                :data="intentionData"
                :translation-name="intentionsTranslation"
            />
            <FormInput
                data-key="contact_email"
                :data="intentionData"
                :translation-name="intentionsTranslation"
            />
            <FormInput
                data-key="contact_phone"
                :data="intentionData"
                :translation-name="intentionsTranslation"
            />
        </FormSection>
    </div>
</template>
